import { GET_PRICING_SCENARIO_REPORT } from './pricing-config-qa-report.types';

export const getPricingScenarioReport = payload => ({
  type: GET_PRICING_SCENARIO_REPORT.BASE,
  payload,
});
